export default __webpack_public_path__ + "static/media/stak.0a741b44.svg";